export type ButtonVariant = 'primary' | 'secondary';

export interface IButtonProps {
    identifier?: string;
    icon?: JSX.Element;
    onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
    variant: ButtonVariant;
    disabled?: boolean;
}

export const Button: React.FC<IButtonProps> = ({ identifier, icon, variant, onClick, disabled = false }) => {
    return (
<button
  disabled={disabled}
  className={`btn d-flex align-items-center justify-content-center gap-2 shadow-sm ${
    variant === 'primary' ? 'btn-primary text-white' : 'btn-outline-primary'
  } ${icon ? 'px-2 py-2' : 'px-4 py-2 text-nowrap'} rounded`}
  style={{
    minWidth: icon && !identifier ? '2.5rem' : '4rem',
    transition: 'all 0.2s ease-in-out',
  }}
  onClick={onClick}
>
  {/* Icon first (only if provided) */}
  {icon && (
    <span
      className="d-flex align-items-center justify-content-center"
      style={{ fontSize: '1.25rem', lineHeight: 1 }}
    >
      {icon}
    </span>
  )}

  {/* Label (only if identifier exists) */}
  {identifier && (
    <span className="fw-semibold" style={{ fontSize: '0.9rem' }}>
      {identifier}
    </span>
  )}
</button>

    );
};
